"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDSHoverTitleString = exports.createIconCellFormatter = exports.certifiedListIconStyle = void 0;
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../../gen-src/Localize");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var StyleFunctions_1 = require("../../style/StyleFunctions");
var CellStyles_1 = require("./CellStyles");
/**
 * This inlines a display: flex; onto the certified icons because the chrome tooltip widget used to
 * create the certification tooltip wraps the svg in its own div with its own styles which ruins the
 * vertical alignment of only the certified icons.
 * The nest selector is for IE11 and will need to exist until ChromeTooltipWidget is refactored away.
 */
exports.certifiedListIconStyle = (0, StyleFunctions_1.cssClass)('IconCell', __assign(__assign({}, CellStyles_1.cellPaddingStyle), { height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 24, $nest: {
        '& > div': {
            display: 'flex !important',
            alignItems: 'center !important',
            justifyContent: 'center !important'
        }
    } }));
var DisabledIconContainer = (0, LayoutComponents_1.divWithStyle)('DisabledIconCell', __assign(__assign({}, CellStyles_1.cellPaddingStyle), { height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 24, opacity: 0.6 }));
function IconCellFormatter(props) {
    return props.disabled ?
        react_1.default.createElement(DisabledIconContainer, { title: props.title }, props.icon)
        :
            react_1.default.createElement("div", { className: exports.certifiedListIconStyle, title: props.title }, props.icon);
}
function createIconCellFormatter(getIconFromRowData, getTitleFromRowData, getDisabledFromRowData) {
    // eslint-disable-next-line react/display-name
    return function (props) { return (react_1.default.createElement(IconCellFormatter, { disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false, icon: getIconFromRowData(props.row.data), title: getTitleFromRowData(props.row.data) })); };
}
exports.createIconCellFormatter = createIconCellFormatter;
function getDSHoverTitleString(isCertified, hasExtracts) {
    if (isCertified) {
        return '';
    }
    else {
        return hasExtracts ? Localize_1.Messages.DataDetailsDatasourceExtract() : Localize_1.Messages.DataDetailsDatasourceLive();
    }
}
exports.getDSHoverTitleString = getDSHoverTitleString;
//# sourceMappingURL=IconCellFormatter.js.map